/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import "./AdminDSR.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import axios from "axios";
import {
  Apiurl,
  GetToken,
  RemoveUserSession,
  downloadFile,
  downloadMultipleFiles,
} from "../../../Utils/utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import HomeTab from "./HomeTab";
import MonthlyReportTab from "./MonthlyReportTab";
import EmployeeDSRTab from "./EmployeeDSRTab";

const AdminDSR = () => {
  const LoginToken = GetToken();
  const navigate = useNavigate();
  const userDropdownRef = useRef(null);

  const [showSidebar, setShowSidebar] = useState(true);
  const [activeTab, setActiveTab] = useState("home");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectFilter, setSelectFilter] = useState("name");
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [monthlyReportData, setMonthlyReportData] = useState([]);
  const [reportTotalTime, setReportTotalTime] = useState("");
  const [reportFilters, setReportFilters] = useState({
    fromDate: "",
    toDate: "",
    projectId: "",
    userId: "",
  });
  const [loadingReport, setLoadingReport] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [filteredTaskList, setFilteredTaskList] = useState([]);
  const [taskSearch, setTaskSearch] = useState("");
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [taskModalData, setTaskModalData] = useState({});
  const [employeeDsrData, setEmployeeDsrData] = useState([]);
  const [loadingEmployeeDsr, setLoadingEmployeeDsr] = useState(false);
  const [dsrFilters, setDsrFilters] = useState({
    fromDate: "",
    toDate: "",
    projectId: "",
    userId: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteProjectName, setDeleteProjectName] = useState("");
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [projectTypes, setProjectTypes] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [notesUrl, setNotesUrl] = useState("");
  const [showDocsModal, setShowDocsModal] = useState(false);
  const [docsList, setDocsList] = useState([]);
  const [loadingEditData, setLoadingEditData] = useState(false);
  const [reportProjects, setReportProjects] = useState([]);
  const [reportEmployees, setReportEmployees] = useState([]);
  const [dsrProjects, setDsrProjects] = useState([]);
  const [dsrEmployees, setDsrEmployees] = useState([]);

  const FILE_PREFIX = "https://attendanceapi.elitewebdemo.com";

  const hasValidNotes = (notes) => {
    return typeof notes === "string" && notes.trim() !== "";
  };

  const getDocPath = (doc) => {
    if (!doc || typeof doc !== "object") return "";
    return doc.ProjectDoument || doc.File || doc.projectDoument || doc.file || "";
  };

  const getValidDocs = (docs) => {
    if (!Array.isArray(docs)) return [];
    return docs.filter((doc) => {
      const path = getDocPath(doc);
      return typeof path === "string" && path.trim() !== "";
    });
  };

  const hasValidDocs = (docs) => {
    return getValidDocs(docs).length > 0;
  };

  const isQuillContentEmpty = (value) => {
    if (!value) return true;

    const plainText = value
      .replace(/<(.|\n)*?>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    return plainText === "";
  };

  const handleViewNotes = (notesFileUrl) => {
    const validNotes = hasValidNotes(notesFileUrl) ? notesFileUrl : "";
    setNotesUrl(
      validNotes
        ? validNotes.startsWith("http")
          ? validNotes
          : FILE_PREFIX + validNotes
        : ""
    );
    setShowNotesModal(true);
  };

  const handleDownloadNotes = (notesFileUrl) => {
    if (!hasValidNotes(notesFileUrl)) return;

    const fullUrl = notesFileUrl.startsWith("http")
      ? notesFileUrl
      : FILE_PREFIX + notesFileUrl;

    const fileName = fullUrl.split("/").pop();
    downloadFile(fullUrl, fileName);
  };

  const handleViewDocs = (docs) => {
    const validDocs = getValidDocs(docs);

    if (validDocs.length === 0) {
      toast.error("No documents available");
      return;
    }

    const formattedDocs = validDocs.map((doc) => {
      const docPath = getDocPath(doc);
      const fullUrl = docPath.startsWith("http")
        ? docPath
        : FILE_PREFIX + docPath;

      return {
        url: fullUrl,
        fileName: docPath.split("\\").pop().split("/").pop(),
      };
    });

    setDocsList(formattedDocs);
    setShowDocsModal(true);
  };

  const handleDownloadAllDocuments = (docsArr) => {
    const validDocs = getValidDocs(docsArr);

    if (validDocs.length === 0) {
      toast.error("No documents available");
      return;
    }

    const files = validDocs.map((doc) => {
      const docPath = getDocPath(doc);
      const fullUrl = docPath.startsWith("http")
        ? docPath
        : FILE_PREFIX + docPath;

      return {
        url: fullUrl,
        fileName: docPath.split("\\").pop().split("/").pop(),
      };
    });

    downloadMultipleFiles(files);
  };

  const handlePreviewSingleDoc = (url) => {
    if (!url) return;
    window.open(url, "_blank");
  };

  const handleDownloadSingleDoc = (url, fileName) => {
    if (!url) return;
    downloadFile(url, fileName);
  };

  const fetchNotesHtmlContent = async (notesFileUrl) => {
    try {
      if (!notesFileUrl || typeof notesFileUrl !== "string") return "";

      const fullUrl = notesFileUrl.startsWith("http")
        ? notesFileUrl
        : FILE_PREFIX + notesFileUrl;

      const response = await axios.get(fullUrl, {
        headers: {
          authorization: `Bearer ${LoginToken}`,
        },
      });

      return response?.data || "";
    } catch (error) {
      console.error("Failed to load notes HTML:", error);
      return "";
    }
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(event.target)
      ) {
        setFormData((prev) => ({
          ...prev,
          showUserDropdown: false,
        }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatTime = (hours, minutes) => {
    const h = hours?.split(":")[0] || "00";
    const m = minutes?.split(":")[1] || "00";
    return `${h} h ${m} m`;
  };

  const fetchProjectTypes = () => {
    setLoadingTypes(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Projects/GetAllProjectTypes`,
    };
    axios(option)
      .then((response) => {
        if (response?.data?.success) {
          const parsedData = JSON.parse(response?.data?.data);
          setProjectTypes(parsedData);
        }
        setLoadingTypes(false);
      })
      .catch((error) => {
        setLoadingTypes(false);
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        } else {
          toast.error("Failed to fetch project types");
        }
      });
  };

  const fetchReportProjects = (userId = "") => {
    const url = userId
      ? `${Apiurl()}/Projects/GetProjectsByUserDropdown?userId=${userId}`
      : `${Apiurl()}/Projects/GetProjectsByUserDropdown`;
    axios({
      method: "GET",
      headers: { "content-type": "application/json", authorization: `Bearer ${LoginToken}` },
      url,
    }).then((response) => {
      if (response?.data?.success) {
        let list = [];
        try {
          const raw = response?.data?.data;
          if (typeof raw === "string") {
            const parsed = JSON.parse(raw);
            list = Array.isArray(parsed) ? parsed : (parsed?.data || parsed?.Data || []);
          } else if (Array.isArray(raw)) {
            list = raw;
          } else {
            list = raw?.data || raw?.Data || [];
          }
        } catch (e) { list = []; }
        setReportProjects(list.map((item) => ({ id: item.ProjectId, name: item.ProjectName })));
      } else {
        setReportProjects([]);
      }
    }).catch(() => setReportProjects([]));
  };

  const fetchReportEmployees = (projectId = "") => {
    const url = projectId
      ? `${Apiurl()}/Admin/GetEmployeesByProject?projectId=${projectId}`
      : `${Apiurl()}/Admin/GetEmployeesByProject`;
    axios({
      method: "GET",
      headers: { "content-type": "application/json", authorization: `Bearer ${LoginToken}` },
      url,
    }).then((response) => {
      if (response?.data?.success) {
        let list = [];
        try {
          const raw = response?.data?.data;
          if (typeof raw === "string") {
            const parsed = JSON.parse(raw);
            list = Array.isArray(parsed) ? parsed : (parsed?.data || parsed?.Data || []);
          } else if (Array.isArray(raw)) {
            list = raw;
          } else {
            list = raw?.data || raw?.Data || [];
          }
        } catch (e) { list = []; }
        setReportEmployees(list.map((item) => ({
          id: item.UserId,
          name: item.Name || `${item.FirstName || ""} ${item.LastName || ""}`.trim()
        })));
      } else {
        setReportEmployees([]);
      }
    }).catch(() => setReportEmployees([]));
  };

  const fetchDsrProjects = (userId = "") => {
    const url = userId
      ? `${Apiurl()}/Projects/GetProjectsByUserDropdown?userId=${userId}`
      : `${Apiurl()}/Projects/GetProjectsByUserDropdown`;
    axios({
      method: "GET",
      headers: { "content-type": "application/json", authorization: `Bearer ${LoginToken}` },
      url,
    }).then((response) => {
      if (response?.data?.success) {
        let list = [];
        try {
          const raw = response?.data?.data;
          if (typeof raw === "string") {
            const parsed = JSON.parse(raw);
            list = Array.isArray(parsed) ? parsed : (parsed?.data || parsed?.Data || []);
          } else if (Array.isArray(raw)) {
            list = raw;
          } else {
            list = raw?.data || raw?.Data || [];
          }
        } catch (e) { list = []; }
        setDsrProjects(list.map((item) => ({ id: item.ProjectId, name: item.ProjectName })));
      } else {
        setDsrProjects([]);
      }
    }).catch(() => setDsrProjects([]));
  };

  const fetchDsrEmployees = (projectId = "") => {
    const url = projectId
      ? `${Apiurl()}/Admin/GetEmployeesByProject?projectId=${projectId}`
      : `${Apiurl()}/Admin/GetEmployeesByProject`;
    axios({
      method: "GET",
      headers: { "content-type": "application/json", authorization: `Bearer ${LoginToken}` },
      url,
    }).then((response) => {
      if (response?.data?.success) {
        let list = [];
        try {
          const raw = response?.data?.data;
          if (typeof raw === "string") {
            const parsed = JSON.parse(raw);
            list = Array.isArray(parsed) ? parsed : (parsed?.data || parsed?.Data || []);
          } else if (Array.isArray(raw)) {
            list = raw;
          } else {
            list = raw?.data || raw?.Data || [];
          }
        } catch (e) { list = []; }
        setDsrEmployees(list.map((item) => ({
          id: item.UserId,
          name: item.Name || `${item.FirstName || ""} ${item.LastName || ""}`.trim()
        })));
      } else {
        setDsrEmployees([]);
      }
    }).catch(() => setDsrEmployees([]));
  };

  const fetchMonthlyReport = () => {
    const { fromDate, toDate, projectId, userId } = reportFilters;
    if (!fromDate || !toDate) {
      toast.error("From Date and To Date are required");
      return;
    }

    setMonthlyReportData([]);
    setReportTotalTime("");
    setLoadingReport(true);

    const payload = {
      data: JSON.stringify({
        FromDate: fromDate,
        ToDate: toDate,
        ProjectId: projectId || "0",
        UserId: userId || "0",
      }),
    };

    const option = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Task/GetMonthlyReport`,
      data: payload,
    };

    axios(option)
      .then((response) => {
        if (response?.data?.success) {
          const parsedData = JSON.parse(response?.data?.data || "{}");
          const projects = parsedData?.Projects || (Array.isArray(parsedData) ? parsedData : []);

          if (!projects.length) {
            setMonthlyReportData([]);
            toast.error("No record found");
            setLoadingReport(false);
            return;
          }

          setMonthlyReportData(projects);
          setReportTotalTime(parsedData?.TotalTime || "");
        } else {
          setMonthlyReportData([]);
          toast.error("No record found");
        }
        setLoadingReport(false);
      })
      .catch((error) => {
        setLoadingReport(false);
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        } else {
          toast.error("No record found");
        }
      });
  };

  const fetchTasksForAdmin = (rowData) => {
    const { fromDate, toDate } = reportFilters;
    if (!fromDate || !toDate) {
      toast.error("From Date and To Date are required");
      return;
    }

    const projectId = rowData.ProjectId || rowData.projectId;
    const userId = rowData.UserId || rowData.userId;

    if (!projectId || !userId) {
      toast.error("ProjectId or UserId missing in row data");
      return;
    }

    setLoadingTasks(true);
    setTaskModalData({
      projectName: rowData.ProjectName,
      employeeName: rowData.UserName,
    });

    const payload = {
      data: JSON.stringify({
        FromDate: fromDate,
        ToDate: toDate,
        ProjectId: projectId,
        UserId: userId,
      }),
    };

    const option = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Task/GetTasksForAdminByUser`,
      data: payload,
    };

    axios(option)
      .then((response) => {
        if (response?.data?.success) {
          const parsedData = JSON.parse(response?.data?.data);
          const tasks = parsedData?.Tasks || [];
          const formattedTasks = tasks.map((item) => ({
            id: item.Id,
            date: item.Date?.split("T")[0],
            task: item.TaskDetail,
            time: formatTime(item.Hours, item.Minutes),
          }));

          setTaskList(formattedTasks);
          setFilteredTaskList(formattedTasks);
          setTaskSearch("");
          setTaskModalData((prev) => ({
            ...prev,
            totalTime: parsedData?.TotalTime || "",
          }));
          setShowTaskModal(true);
        } else {
          toast.error("No tasks found");
        }
        setLoadingTasks(false);
      })
      .catch(() => {
        setLoadingTasks(false);
        toast.error("Failed to fetch tasks");
      });
  };

  const fetchEmployeeDsr = () => {
    const { fromDate, toDate, projectId, userId } = dsrFilters;

    if (!fromDate || !toDate) {
      toast.error("From Date and To Date are required");
      return;
    }

    if (!userId || userId === "0" || userId === "") {
      toast.error("Please select employee");
      return;
    }

    setEmployeeDsrData([]);
    setLoadingEmployeeDsr(true);

    const requestData = {
      UserId: userId || "0",
      ProjectId: projectId || "0",
      ...(fromDate && toDate && { FromDate: fromDate, ToDate: toDate }),
    };

    const payload = {
      data: JSON.stringify(requestData),
    };

    axios({
      method: "POST",
      url: `${Apiurl()}/Task/GetTasksForAdminByUser`,
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      data: payload,
    })
      .then((response) => {
        if (response?.data?.success) {
          const parsedData = JSON.parse(response?.data?.data || "{}");
          const tasks = parsedData?.Tasks || (Array.isArray(parsedData) ? parsedData : []);

          if (!tasks || tasks.length === 0) {
            setEmployeeDsrData([]);
            toast.error("No record found");
            setLoadingEmployeeDsr(false);
            return;
          }

          const formatted = tasks.map((item) => {
            let projName = "";
            if (item.ProjectName) {
              projName = item.ProjectName;
            } else if (typeof item.Project === "string" && item.Project) {
              projName = item.Project;
            } else if (item.Project && typeof item.Project === "object") {
              projName =
                item.Project.ProjectName ||
                item.Project.name ||
                item.Project.Title ||
                "";
            } else if (item.ProjectTitle) {
              projName = item.ProjectTitle;
            }

            if (!projName && (item.ProjectId || item.projectId)) {
              const pId = item.ProjectId || item.projectId;
              const foundProject =
                dsrProjects.find((p) => String(p.id) === String(pId)) ||
                projects.find((p) => String(p.id) === String(pId)) ||
                reportProjects.find((p) => String(p.id) === String(pId));
              if (foundProject) {
                projName = foundProject.name;
              }
            }

            let empName =
              employees.find((e) => Number(e.id) === Number(item.UserId))
                ?.name ||
              dsrEmployees.find((e) => Number(e.id) === Number(item.UserId))
                ?.name ||
              reportEmployees.find((e) => Number(e.id) === Number(item.UserId))
                ?.name ||
              item.UserName ||
              item.EmployeeName ||
              "";

            return {
              id: item.Id,
              date: item.Date?.split("T")[0],
              employee: empName,
              project: projName,
              task: item.TaskDetail,
              hours: formatTime(item.Hours, item.Minutes),
            };
          });

          setEmployeeDsrData(formatted);
        } else {
          setEmployeeDsrData([]);
          toast.error("No record found");
        }
        setLoadingEmployeeDsr(false);
      })
      .catch(() => {
        setLoadingEmployeeDsr(false);
        toast.error("Failed to fetch data");
      });
  };

  const handleDeleteTask = (id) => {
    const payloadString = `{'Id':'${id}'}`;
    const option = {
      method: "POST",
      headers: {
        authorization: `Bearer ${LoginToken}`,
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Task/DeleteTask`,
      data: {
        data: payloadString,
      },
    };

    axios(option)
      .then(() => {
        toast.success("Task deleted successfully");
        setEmployeeDsrData((prev) => prev.filter((item) => item.id !== id));
        setShowDeleteModal(false);
        setDeleteId(null);
        setDeleteProjectName("");
      })
      .catch(() => {
        toast.error("Failed to delete task");
        setShowDeleteModal(false);
        setDeleteProjectName("");
      });
  };

  const handleDeleteProject = (projectId) => {
    if (!projectId) {
      toast.error("Project Id is missing");
      return;
    }

    const option = {
      method: "POST",
      headers: {
        authorization: `Bearer ${LoginToken}`,
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Projects/DeleteProjectDSR?projectId=${projectId}`,
    };

    axios(option)
      .then((response) => {
        if (response?.data?.success) {
          toast.success(
            response?.data?.message || "Project deleted successfully"
          );
          fetchProjects();
        } else {
          toast.error(response?.data?.message || "Failed to delete project");
        }

        setShowDeleteModal(false);
        setDeleteId(null);
        setDeleteProjectName("");
        setModalType("");
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message || "Failed to delete project"
        );
        setShowDeleteModal(false);
        setDeleteId(null);
        setDeleteProjectName("");
        setModalType("");
      });
  };

  const formatToBackendTime = (value, type) => {
    const num = Number(value || 0);
    if (type === "hour") {
      return `${String(num).padStart(2, "0")}:00:00`;
    }
    if (type === "minute") {
      return `00:${String(num).padStart(2, "0")}:00`;
    }
    return "00:00:00";
  };

  const fetchProjects = () => {
    setLoadingProjects(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Projects/GetAllProjects`,
    };
    axios(option)
      .then((response) => {
        if (response?.data?.success) {
          const parsed = JSON.parse(response.data.data || "{}");
          const projectsArray = parsed?.Data || [];
          const formattedProjects = projectsArray.map((item) => {
            const assignedUsers = Array.isArray(item.AssignedUsers)
              ? item.AssignedUsers
              : [];
            const assignedUserIds = Array.isArray(item.AssignedUserIds)
              ? item.AssignedUserIds.map((id) => String(id))
              : [];
            const assignedUserNames = assignedUsers
              .map((user) => user.UserName || user.Email || "")
              .filter(Boolean);
            return {
              id: item.Project?.ProjectId,
              name: item.Project?.ProjectName || "",
              type: item.Project?.ProjectTypeNavigation?.ProjectType1 || "",
              projectTypeId: item.Project?.ProjectType || "",
              assignedUserIds,
              assignedUserNames,
              assignedUserName: assignedUserNames.join(", "),
              projectNotesFile: item.Project?.ProjectNotesFile || "",
              projectDocuments: Array.isArray(item.Documents)
                ? item.Documents
                : Array.isArray(item.ProjectDocuments)
                  ? item.ProjectDocuments
                  : [],
            };
          });
          setProjects(formattedProjects);
        } else {
          setProjects([]);
        }
        setLoadingProjects(false);
      })
      .catch((error) => {
        setLoadingProjects(false);
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        } else {
          toast.error("Failed to fetch projects");
        }
      });
  };

  const fetchEmployees = () => {
    setLoadingEmployees(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetAllEmployees`,
    };
    axios(option)
      .then((response) => {
        if (response?.data?.success) {
          const firstParse = JSON.parse(response?.data?.data);
          const formattedEmployees = firstParse.map((item) => ({
            id: item.UserId,
            name: `${item.FirstName || ""} ${item.LastName || ""}`.trim(),
          }));
          setEmployees(formattedEmployees);
        }
        setLoadingEmployees(false);
      })
      .catch((error) => {
        setLoadingEmployees(false);
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        } else {
          toast.error("Failed to fetch employees");
        }
      });
  };

  const handleUpdateTask = () => {
    if (!formData.date || !formData.projectId || !formData.task) {
      toast.error("Please fill all required fields");
      return;
    }

    const formattedHours = formatToBackendTime(formData.hours, "hour");
    const formattedMinutes = formatToBackendTime(formData.minutes, "minute");

    const payloadString = `{
        'Id':'${formData.Id}',
        'Date':'${formData.date}',
        'ProjectId':'${formData.projectId}',
        'UserId':'${formData.userId}',
        'Hours':'${formattedHours}',
        'Minutes':'${formattedMinutes}',
        'TaskDetail':'${formData.task}'
    }`;

    axios({
      method: "POST",
      url: `${Apiurl()}/Task/SaveTaskDetail`,
      headers: {
        authorization: `Bearer ${LoginToken}`,
        "content-type": "application/json",
      },
      data: {
        data: payloadString,
      },
    })
      .then(() => {
        toast.success("Task updated successfully");
        setEmployeeDsrData((prev) =>
          prev.map((item) =>
            item.id === formData.Id
              ? {
                ...item,
                date: formData.date,
                project:
                  projects.find((p) => p.id === Number(formData.projectId))
                    ?.name || "",
                task: formData.task,
                hours: `${formData.hours} h ${formData.minutes} m`,
              }
              : item
          )
        );

        closeModal();
      })
      .catch(() => {
        toast.error("Failed to update task");
      });
  };

  const handleUserCheckboxChange = (userId) => {
    const stringId = String(userId);
    const selectedIds = formData.AssignedUserIds || [];
    const isSelected = selectedIds.includes(stringId);

    const updatedIds = isSelected
      ? selectedIds.filter((id) => id !== stringId)
      : [...selectedIds, stringId];

    setFormData({
      ...formData,
      AssignedUserIds: updatedIds,
    });
  };

  const getSelectedUserNames = () => {
    if (
      !Array.isArray(formData.AssignedUserIds) ||
      formData.AssignedUserIds.length === 0
    ) {
      return "Select Users";
    }

    const selectedNames = employees
      .filter((emp) => formData.AssignedUserIds.includes(String(emp.id)))
      .map((emp) => emp.name);

    if (selectedNames.length <= 2) {
      return selectedNames.join(", ");
    }

    return `${selectedNames[0]}, ${selectedNames[1]} + ${selectedNames.length - 2
      } more`;
  };

  const getAllSelectedUserNames = () => {
    if (
      !Array.isArray(formData.AssignedUserIds) ||
      formData.AssignedUserIds.length === 0
    ) {
      return "Select Users";
    }

    return employees
      .filter((emp) => formData.AssignedUserIds.includes(String(emp.id)))
      .map((emp) => emp.name)
      .join(", ");
  };

  useEffect(() => {
    fetchProjects();
    fetchProjectTypes();
    fetchEmployees();
    fetchReportProjects();
    fetchReportEmployees();
    fetchDsrProjects();
    fetchDsrEmployees();
  }, []);

  useEffect(() => {
    if (activeTab !== "home") return;

    if (!searchTerm.trim()) {
      setFilteredData([]);
      return;
    }

    const filtered = projects.filter((item) => {
      let value = "";

      if (selectFilter === "name") {
        value = item.name;
      } else if (selectFilter === "type") {
        value = item.type;
      } else if (selectFilter === "assignedUser") {
        value = item.assignedUserName;
      }

      return value?.toLowerCase().includes(searchTerm.toLowerCase());
    });

    setFilteredData(filtered);
  }, [searchTerm, selectFilter, projects, activeTab]);

  const openModal = async (type, item = null) => {
    setModalType(type);
    setEditingItem(item);

    if (type === "addProject" && item) {
      setShowModal(true);
      setLoadingEditData(true);

      const existingNotesFile = item.projectNotesFile || "";
      let existingHtmlContent = "";

      if (existingNotesFile) {
        existingHtmlContent = await fetchNotesHtmlContent(existingNotesFile);
      }

      setFormData({
        Id: item.id,
        ProjectName: item.name,
        ProjectType: item.projectTypeId,
        AssignedUserIds: item.assignedUserIds || [],
        ExistingProjectNotesFile: existingNotesFile,
        ExistingProjectDocuments: item.projectDocuments || [],
        ProjectNoteHtmlContent: existingHtmlContent || "",
        ProjectDocumentsFiles: [],
        showUserDropdown: false,
      });

      setLoadingEditData(false);
    } else if (type === "editDSR" && item) {
      const [h = "0"] = item.hours?.split(" ")[0]?.split("h") || [];
      const minutesPart = item.hours?.split(" ")[2] || "0";

      setFormData({
        Id: item.id,
        date: item.date,
        projectId: projects.find((p) => p.name === item.project)?.id || "",
        projectName: item.project,
        employeeName: item.employee,
        userId: employees.find((e) => e.name === item.employee)?.id || "",
        hours: h.trim(),
        minutes: minutesPart.trim(),
        task: item.task,
      });

      setShowModal(true);
    } else {
      setFormData({
        AssignedUserIds: [],
        ProjectName: "",
        ProjectType: "",
        ExistingProjectNotesFile: "",
        ExistingProjectDocuments: [],
        ProjectNoteHtmlContent: "",
        ProjectDocumentsFiles: [],
        showUserDropdown: false,
      });
      setShowModal(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setFormData({});
    setEditingItem(null);
    setLoadingEditData(false);
  };

  const handleFormSubmit = () => {
    if (modalType === "addProject") {
      const hasProjectName = (formData.ProjectName || "").trim() !== "";
      const hasProjectType =
        (formData.ProjectType || "").toString().trim() !== "";
      const hasAssignedUser =
        Array.isArray(formData.AssignedUserIds) &&
        formData.AssignedUserIds.length > 0;

      const hasNewNotes = !isQuillContentEmpty(
        formData.ProjectNoteHtmlContent || ""
      );
      const hasExistingNotes = hasValidNotes(formData.ExistingProjectNotesFile);

      const hasNewDocs =
        Array.isArray(formData.ProjectDocumentsFiles) &&
        formData.ProjectDocumentsFiles.length > 0;

      const hasExistingDocs =
        Array.isArray(formData.ExistingProjectDocuments) &&
        getValidDocs(formData.ExistingProjectDocuments).length > 0;

      if (!hasProjectName) {
        toast.error("Project Name is required");
        return;
      }

      if (!hasProjectType) {
        toast.error("Project Type is required");
        return;
      }

      if (!hasAssignedUser) {
        toast.error("Assign User is required");
        return;
      }

      if (!hasNewNotes && !hasExistingNotes) {
        toast.error("Project Notes is required");
        return;
      }

      // if (!hasNewDocs && !hasExistingDocs) {
      //   toast.error("Project Document is required");
      //   return;
      // }

      const formDataPayload = new FormData();

      formDataPayload.append(
        "ProjectId",
        editingItem ? String(formData.Id) : "0"
      );
      formDataPayload.append("ProjectName", formData.ProjectName);
      formDataPayload.append("ProjectType", formData.ProjectType);

      (formData.AssignedUserIds || []).forEach((id) => {
        formDataPayload.append("AssignedUserIds", id);
      });

      if (!isQuillContentEmpty(formData.ProjectNoteHtmlContent || "")) {
        const blob = new Blob([formData.ProjectNoteHtmlContent], {
          type: "text/html",
        });

        const htmlFile = new File(
          [blob],
          `${formData.ProjectName || "project-notes"}.html`,
          { type: "text/html" }
        );

        formDataPayload.append("ProjectNoteHtmlFile", htmlFile);
      }

      if (hasNewDocs) {
        formData.ProjectDocumentsFiles.forEach((file) => {
          formDataPayload.append("ProjectDocumentsFiles", file);
        });
      }

      const option = {
        method: "POST",
        headers: {
          authorization: `Bearer ${LoginToken}`,
        },
        url: `${Apiurl()}/Projects/SaveProjectDsr`,
        data: formDataPayload,
      };

      axios(option)
        .then((response) => {
          if (response?.data?.success) {
            toast.success("Project saved successfully");
            closeModal();
            fetchProjects();
          } else {
            toast.error(response?.data?.message || "Something went wrong");
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            toast.error("Your session has expired");
            RemoveUserSession();
            navigate("/", { replace: true });
          } else {
            toast.error(error?.response?.data?.message || "Error saving project");
          }
        });
    }
  };

  const handleDeleteConfirm = () => {
    if (!deleteId) return;

    if (modalType === "deleteProject") {
      handleDeleteProject(deleteId);
    } else {
      handleDeleteTask(deleteId);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
    setDeleteProjectName("");
    setModalType("");
  };

  let displayData = [];
  if (activeTab === "home") {
    displayData = searchTerm ? filteredData : projects;
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchTerm("");
    setFilteredData([]);
    setMonthlyReportData([]);
    setEmployeeDsrData([]);
    setTaskList([]);
    setFilteredTaskList([]);
    setTaskSearch("");
    setReportFilters({
      fromDate: "",
      toDate: "",
      projectId: "",
      userId: "",
    });
    setDsrFilters({
      fromDate: "",
      toDate: "",
      projectId: "",
      userId: "",
    });
    closeModal();
  };

  const handleReportReset = () => {
    setReportFilters({
      fromDate: "",
      toDate: "",
      projectId: "",
      userId: "",
    });
    setMonthlyReportData([]);
    fetchReportProjects();
    fetchReportEmployees();
  };

  const handleDsrReset = () => {
    setDsrFilters({
      fromDate: "",
      toDate: "",
      projectId: "",
      userId: "",
    });
    setEmployeeDsrData([]);
    fetchDsrProjects();
    fetchDsrEmployees();
  };

  const calculateTotalTime = () => {
    if (!monthlyReportData.length) return "0 h 0 m";

    let totalMinutes = 0;

    monthlyReportData.forEach((item) => {
      const time = item.TotalTime || "0 h 0 m";
      const hoursMatch = time.match(/(\d+)\s*h/);
      const minutesMatch = time.match(/(\d+)\s*m/);

      const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
      const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;

      totalMinutes += hours * 60 + minutes;
    });

    const finalHours = Math.floor(totalMinutes / 60);
    const finalMinutes = totalMinutes % 60;

    return `${finalHours} h ${finalMinutes} m`;
  };

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-AdminDSR"
              : "main-container-of-all-employees-page-new-AdminDSR"
          }
        >
          <div className="inner-container-of-all-employees-page">
            <div className="header-of-employees-page">
              <div className="all-employee-AdminDSR">
                <h4>Admin DSR</h4>
              </div>
              <div className="all-employees-AdminDSR">
                <div className="home-icon-AdminDSR">
                  <BiHomeAlt className="home-icon-header-AdminDSR" />
                </div>
                <div className="arrow-icon-AdminDSR">
                  <MdKeyboardArrowRight />
                </div>
                <div className="employee-text-AdminDSR">
                  <p>DSR Management</p>
                </div>
              </div>
            </div>
          </div>

          <div className="tabs-section-AdminDSR">
            <button
              className={`tab-button ${activeTab === "home" ? "active" : ""}`}
              onClick={() => handleTabChange("home")}
            >
              Home
            </button>
            <button
              className={`tab-button ${activeTab === "report" ? "active" : ""}`}
              onClick={() => handleTabChange("report")}
            >
              Generate Monthly Report
            </button>
            <button
              className={`tab-button ${activeTab === "dsr" ? "active" : ""}`}
              onClick={() => handleTabChange("dsr")}
            >
              Show Employee DSR
            </button>
          </div>

          <div className="body-part-outer-AdminDSR">
            {activeTab === "home" && (
              <HomeTab
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                selectFilter={selectFilter}
                setSelectFilter={setSelectFilter}
                displayData={displayData}
                showNotesModal={showNotesModal}
                setShowNotesModal={setShowNotesModal}
                notesUrl={notesUrl}
                handleViewNotes={handleViewNotes}
                handleDownloadNotes={handleDownloadNotes}
                showDocsModal={showDocsModal}
                setShowDocsModal={setShowDocsModal}
                docsList={docsList}
                handleViewDocs={handleViewDocs}
                handleDownloadAllDocuments={handleDownloadAllDocuments}
                handlePreviewSingleDoc={handlePreviewSingleDoc}
                handleDownloadSingleDoc={handleDownloadSingleDoc}
                getValidDocs={getValidDocs}
                hasValidNotes={hasValidNotes}
                showModal={showModal}
                modalType={modalType}
                closeModal={closeModal}
                formData={formData}
                setFormData={setFormData}
                projectTypes={projectTypes}
                employees={employees}
                loadingEditData={loadingEditData}
                handleFormSubmit={handleFormSubmit}
                handleUserCheckboxChange={handleUserCheckboxChange}
                getSelectedUserNames={getSelectedUserNames}
                getAllSelectedUserNames={getAllSelectedUserNames}
                userDropdownRef={userDropdownRef}
                hasValidDocs={hasValidDocs}
                getDocPath={getDocPath}
                FILE_PREFIX={FILE_PREFIX}
                downloadFile={downloadFile}
                showDeleteModal={showDeleteModal}
                setShowDeleteModal={setShowDeleteModal}
                deleteId={deleteId}
                setDeleteId={setDeleteId}
                deleteProjectName={deleteProjectName}
                setDeleteProjectName={setDeleteProjectName}
                setModalType={setModalType}
                handleDeleteConfirm={handleDeleteConfirm}
                handleDeleteCancel={handleDeleteCancel}
                openModal={openModal}
              />
            )}

            {activeTab === "report" && (
              <MonthlyReportTab
                reportFilters={reportFilters}
                setReportFilters={setReportFilters}
                reportProjects={reportProjects}
                reportEmployees={reportEmployees}
                fetchReportEmployees={fetchReportEmployees}
                fetchReportProjects={fetchReportProjects}
                fetchMonthlyReport={fetchMonthlyReport}
                handleReportReset={handleReportReset}
                monthlyReportData={monthlyReportData}
                reportTotalTime={reportTotalTime}
                fetchTasksForAdmin={fetchTasksForAdmin}
                showTaskModal={showTaskModal}
                setShowTaskModal={setShowTaskModal}
                taskModalData={taskModalData}
                filteredTaskList={filteredTaskList}
                taskSearch={taskSearch}
                setTaskSearch={setTaskSearch}
                taskList={taskList}
                setFilteredTaskList={setFilteredTaskList}
              />
            )}

            {activeTab === "dsr" && (
              <EmployeeDSRTab
                dsrFilters={dsrFilters}
                setDsrFilters={setDsrFilters}
                dsrProjects={dsrProjects}
                dsrEmployees={dsrEmployees}
                fetchDsrEmployees={fetchDsrEmployees}
                fetchDsrProjects={fetchDsrProjects}
                fetchEmployeeDsr={fetchEmployeeDsr}
                handleDsrReset={handleDsrReset}
                employeeDsrData={employeeDsrData}
                showModal={showModal}
                modalType={modalType}
                closeModal={closeModal}
                formData={formData}
                setFormData={setFormData}
                projects={projects}
                handleUpdateTask={handleUpdateTask}
                showDeleteModal={showDeleteModal}
                setShowDeleteModal={setShowDeleteModal}
                deleteId={deleteId}
                setDeleteId={setDeleteId}
                deleteProjectName={deleteProjectName}
                setDeleteProjectName={setDeleteProjectName}
                handleDeleteConfirm={handleDeleteConfirm}
                handleDeleteCancel={handleDeleteCancel}
                openModal={openModal}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDSR;